import React from 'react';
import NavBar from '../components/navbar';
import '../styles/home.css';
import { Typography, Button } from '@material-ui/core';
import gruppenfoto from '../img/gruppenfoto.png';
import { klassen as klassenGewinnspiel } from './gewinnspiel';

const titleRootClass = "home title root";
const titlePictureClass = "home title picture";
const titleTextClass = "home title text";
const contentRootClass = "home content root";
const contentInlineImageClass = "home content image inline";
const buttonRootClass = "home button root";
// const leftSuffix = " left";
const rightSuffix = " right";

class Home extends React.Component {
    render() {
        return (
            <>
                <NavBar />
                <div className={titleRootClass}>
                    <div className={titlePictureClass}></div>
                    <div className={titleTextClass}>
                        <Typography variant="h1">Grundwissen Mathematik</Typography>
                        <Typography variant="h3">Gymnasium Tegernsee</Typography>
                    </div>
                </div>
                <div className={contentRootClass}>
                    <Typography variant="h3">Von Schülern, für Schüler!</Typography>
                    <img className={contentInlineImageClass + rightSuffix} src={gruppenfoto} alt="Unser Teamfoto" title="Unser Teamfoto" />
                    <Typography>
                        Im Zuge des P-Seminars "Grund&shy;wis&shy;sens&shy;samm&shy;lung Ma&shy;the&shy;ma&shy;tik" haben 12 Schüler der Oberstufe des Gymnasiums Tegernsee eine eine Sammlung des re&shy;le&shy;van&shy;ten Stoffes der 5. bis 10. Jahr&shy;gangs&shy;stu&shy;fe und pas&shy;sen&shy;de Übungs&shy;auf&shy;ga&shy;ben erstellt.
                    </Typography>
                    <Typography>
                        Wir sind der Meinung, dass wir als Schüler den Stoff nochmal aus einer anderen Pers&shy;pek&shy;ti&shy;ve ver&shy;mit&shy;teln können, da wir die be&shy;son&shy;der&shy;en He&shy;raus&shy;for&shy;de&shy;rung&shy;en des je&shy;wei&shy;li&shy;gen Themas erst, mehr oder weniger kürzlich, selbst erlebt haben.
                    </Typography>
                    <Typography>
                        Wir hoffen, dass euch unsere Grund&shy;wis&shy;sens&shy;samm&shy;lung gefällt und beim Mathe lernen wei&shy;ter&shy;hilft!
                    </Typography>
                    <Typography variant="h3">Gewinnspiel</Typography>
                    <Typography>
                        Mach jetzt bei unserem Ge&shy;winn&shy;spiel mit und hab die einmalige Chance eine von den Er&shy;stel&shy;lern signierte Grund&shy;wis&shy;sens&shy;samm&shy;lung und eine zu&shy;sätz&shy;li&shy;che Über&shy;ra&shy;schung zu gewinnen!
                        Klicke einfach auf den Link für deine Jahr&shy;gangs&shy;stu&shy;fe und mach mit:
                    </Typography>
                    <div className={buttonRootClass}>
                        {klassenGewinnspiel.map(klasse =>
                            <Button variant="contained" color="primary" href={'/gewinnspiel/' + klasse}>{klasse}. Klasse</Button>
                        )}
                    </div>
                </div>

            </>
        );
    }
}

export default Home;